import InvestigationConfigCollection from './InvestigationConfigCollection';

class InvestigationConfigStore {
  collection: InvestigationConfigCollection;

  constructor() {
    this.collection = new InvestigationConfigCollection();
  }
}

export default new InvestigationConfigStore();
